module.exports = __webpack_public_path__ + "img/bank-check.5c3b7fc0.svg";